import clsx from 'clsx';

const toneStyles = {
  success: 'bg-emerald-500 text-white shadow-emerald-500/30',
  error: 'bg-rose-500 text-white shadow-rose-500/30',
  info: 'bg-brand-navy text-white shadow-brand-navy/30',
};

// Renderiza toasts flotantes con apariencia consistente
export function ToastStack({ toasts, onDismiss }) {
  return (
    <div className="fixed right-6 top-6 z-50 flex w-80 flex-col gap-3">
      {toasts.map(toast => (
        <div
          key={toast.id}
          role="status"
          className={clsx(
            'flex items-start justify-between gap-3 rounded-2xl px-4 py-3 text-sm shadow-lg backdrop-blur-sm',
            'border border-white/10 dark:border-slate-700/40',
            toneStyles[toast.type] || toneStyles.info,
          )}
        >
          <span className="font-semibold">{toast.message}</span>
          <button
            type="button"
            className="text-xs font-bold uppercase tracking-wide text-white/80 transition hover:text-white"
            onClick={() => onDismiss(toast.id)}
            aria-label="Cerrar notificación"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}

export default ToastStack;
